export const types = {
    DELETE: 'DELETE-METHOD',
    GET: 'GET-METHOD',
    PATCH: 'PATCH-METHOD',
    POST: 'POST-METHOD',
    PUT: 'PUT-METHOD'
};